import { render, staticRenderFns } from "./PatientExaminationsList.vue?vue&type=template&id=07dd991a&scoped=true"
import script from "./PatientExaminationsList.vue?vue&type=script&lang=js"
export * from "./PatientExaminationsList.vue?vue&type=script&lang=js"
import style0 from "./PatientExaminationsList.vue?vue&type=style&index=0&id=07dd991a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07dd991a",
  null
  
)

export default component.exports